import React, { useState, useEffect } from "react";
import { handleRequest } from "../utils/api";

const SsPrice = ({
  password,
  setPassword,
  setMessage,
  currentPrice,
  setCurrentPrice,
}) => {
  const [price, setPrice] = useState(currentPrice);

  useEffect(() => {
    setPrice(currentPrice);
  }, [currentPrice]);

  const handleSetPrice = async () => {
    if (!password) {
      alert("비밀번호를 입력해주세요.");
      // setMessage("비밀번호를 입력해주세요.");
      return;
    }
    if (!price || isNaN(price)) {
      alert("유효한 가격을 입력해주세요.");
      return;
    }

    const userConfirmed = window.confirm(
      `현재 가격을 ${price} 원으로 설정하시겠습니까?`
    );
    if (!userConfirmed) {
      return;
    }

    try {
      const response = await handleRequest("/admin/token/setprice", {
        tokenPrice: price,
        adminPassword: password,
      });

      // 응답이 에러인지 확인
      if (response.status === "error") {
        alert(
          "에러: " + (response.message || "알 수 없는 오류가 발생했습니다.")
        );
        // setMessage(
        //   "에러: " + (response.message || "알 수 없는 오류가 발생했습니다.")
        // );
        return;
      }

      // 성공 응답 확인
      if (response.status === "success" || !response.status) {
        alert("가격이 성공적으로 변경되었습니다.");
        // setMessage("가격이 성공적으로 변경되었습니다.");
        setCurrentPrice(price);
      } else {
        alert("가격 변경 중 오류가 발생했습니다.");
        // setMessage("가격 변경 중 오류가 발생했습니다.");
      }
    } catch (error) {
      console.error("가격 변경 중 오류 발생:", error);

      // 백엔드에서 반환한 에러 응답 확인
      if (error.response?.data) {
        const errorData = error.response.data;
        if (errorData.status === "error") {
          alert(
            "에러: " + (errorData.message || "알 수 없는 오류가 발생했습니다.")
          );
          // setMessage(
          //   "에러: " + (errorData.message || "알 수 없는 오류가 발생했습니다.")
          // );
          return;
        }
      }

      let errorMsg = "";
      if (error.response?.data?.error) {
        errorMsg = String(error.response.data.error);
      } else if (error.response?.data?.message) {
        errorMsg = String(error.response.data.message);
      } else if (error.message) {
        errorMsg = String(error.message);
      } else {
        errorMsg = "알 수 없는 오류가 발생했습니다.";
      }

      alert("가격 변경 중 오류가 발생했습니다.");
      // setMessage("가격 변경 중 오류가 발생했습니다: " + errorMsg);
    }
  };

  return (
    <div className="ss-area">
      <div className="sub-tit-area">
        <div className="dot-container">
          <span className="dot outer"></span>
          <span className="dot inner"></span>
        </div>
        <p>지디파이낸스 현재 가격 :</p>
        <span className="value" id="prevPrice">
          {currentPrice} 원
        </span>
      </div>
      <div className="sub-tit-area">
        <div className="dot-container">
          <span className="dot outer"></span>
          <span className="dot inner"></span>
        </div>
        <p>지디파이낸스 가격 변경</p>
      </div>
      <div className="input-area">
        <div className="input-wrapper">
          <input
            type="number"
            id="price"
            className="inp3 body-n"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
          <span className="label body-n d-gray">원</span>
        </div>
      </div>
      <div className="button-area">
        <button className="solid m-button" onClick={handleSetPrice}>
          변경
        </button>
      </div>
    </div>
  );
};

export default SsPrice;
